export const setDepositConfigData = (data) => ({
    type:"SET_DEPOSIT_CONFIG_DATA",
    data
})
